// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.draft {
  font-style: italic;
}

.faded {
  opacity: 0.8;
}

.app-fixtures-table .container .table-bpp-report th,
.app-fixtures-table .container .table-bpp-report td {
  border-top: 1px solid #dee2e6;
  border-bottom: unset;
}

.app-fixtures-table .container {
  height: calc(100vh - 190px - 1.5rem);
  overflow-y: auto;
}

.table-bpp {
  border-collapse: separate;
  border-spacing: 0;
}
.table-bpp thead th {
  position: sticky;
  top: 0;
  background-color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/components/fixtures/fixtures-clubs-table/fixtures-clubs-table.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAIE;;EAEE,6BAAA;EACA,oBAAA;AADJ;;AAMA;EACE,oCAAA;EACA,gBAAA;AAHF;;AAMA;EACE,yBAAA;EACA,iBAAA;AAHF;AAKI;EACE,gBAAA;EACA,MAAA;EACA,uBAAA;AAHN","sourcesContent":[".draft {\n  font-style: italic;\n}\n\n.faded {\n  opacity: 0.8;\n}\n\n.app-fixtures-table .container .table-bpp-report {\n\n  th,\n  td {\n    border-top: 1px solid #dee2e6;\n    border-bottom: unset;\n  }\n\n}\n\n.app-fixtures-table .container {\n  height: calc(100vh - 190px - 1.5rem);\n  overflow-y: auto;\n}\n\n.table-bpp {\n  border-collapse: separate;\n  border-spacing: 0;\n  thead {\n    th {\n      position: sticky;\n      top: 0;\n      background-color: white;\n\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
